import { exec, execForm, getApiToken } from '../utils';
import type {
  DetailsResult,
  UpdateParentSkuDetailsExecVariables,
  UpdateParentSkuDetailsExecResponse
} from '@src/types';

interface UpdateParentSkuDetailsArgs extends UpdateParentSkuDetailsExecVariables {
  files?: { [key: string]: File };
  imageKeysByColorway?: { [colorway: string]: string[] };
}

export const updateParentSkuDetails = async (args: UpdateParentSkuDetailsArgs): Promise<DetailsResult> => {
  const { files, imageKeysByColorway, token, ...updateFields } = args;

  const apiToken = await getApiToken(token);

  const query = `
      mutation updateParentSkuDetails(
        $parentSku: String!
        $partnerCode: String!
        $token: String!
        $productName: String
        $productDescription: String
        $availability: [String]
        $makeAvailabilitiesConsistent: Boolean
        $departments: [String]
        $categories: [String]
        $partnerCategory: String
        $gender: CodeNameInputTypeRestUser
        $msrpPrice: Int
        $taxCode: String
        $brandDisplay: String
        $rubricCode: String
        $imageKeysByColorway: JSON
      ) {
        restUser(token: $token) {
          partner(code: $partnerCode) {
            updateParentSkuDetails(
              parentSku: $parentSku
              productName: $productName
              productDescription: $productDescription
              availability: $availability
              makeAvailabilitiesConsistent: $makeAvailabilitiesConsistent
              departments: $departments
              categories: $categories
              partnerCategory: $partnerCategory
              gender: $gender
              msrpPrice: $msrpPrice
              taxCode: $taxCode
              brandDisplay: $brandDisplay
              rubricCode: $rubricCode
              imageKeysByColorway: $imageKeysByColorway
            ) {
              productName
              productDescription
              availability
              isInconsistentAvailability
              departments
              categories
              partnerCategory
              gender {
                code
                name
              }
              msrpPrice
              taxCode
              brandDisplay
              rubricCode
              numberOfRecords
              variants {
                colorCode
                colorDisplay
                variantCount
                skus
                sizeDisplays
                partnerImageUrls
              }
            }
          }
        }
      }
    `;

  const variables = {
    ...updateFields,
    token: apiToken,
    ...(imageKeysByColorway && { imageKeysByColorway }),
  };

  // If there are files to upload, use execForm; otherwise use regular exec
  if (files && Object.keys(files).length > 0) {
    const data = await execForm<typeof variables, UpdateParentSkuDetailsExecResponse>(
      query,
      variables,
      files
    );
    return data.restUser.partner.updateParentSkuDetails;
  } else {
    const data = await exec<typeof variables, UpdateParentSkuDetailsExecResponse>(
      query,
      { variables }
    );
    return data.restUser.partner.updateParentSkuDetails;
  }
};
